<script setup lang="ts">
import {computed, type PropType, ref} from 'vue';
import {ElInput, ElInputNumber, ElOption, ElSelect} from 'element-plus';
import {CabInitiatief, CabOrganization, InitiatiefFaseEnum, InitiatiefFaseEnum_name, uuidOf} from 'common';
import {INITIATIEF_CHANGE_EMIT, INITIATIEF_REMOVE_EMIT} from '@/base/cabConstants';
import DeleteButton from '@/views/icons/DeleteIcon.vue';

const emits = defineEmits([INITIATIEF_REMOVE_EMIT, INITIATIEF_CHANGE_EMIT]);
const props = defineProps({
    initiatief: {
        type    : Object as PropType<CabInitiatief>,
        required: true,
    },
    allOrganizations: {
        type    : Array as PropType<CabOrganization[]>,
        required: true,
    },
});

const initiatief     = ref<CabInitiatief>(props.initiatief);
const organizationId = computed<string | undefined>({
    get: () => initiatief.value.organization[0] ? uuidOf(initiatief.value.organization[0]) : undefined,
    set: (id: string | undefined) => {
        const org: CabOrganization | undefined = props.allOrganizations.find(o => uuidOf(o) === id);
        initiatief.value.organization          = org ? [org] : [];
        onChange();
    },
});

function onChange() {
    emits(INITIATIEF_CHANGE_EMIT, initiatief.value);
}

function onDelete() {
    emits(INITIATIEF_REMOVE_EMIT, initiatief.value);
}
</script>

<template>
    <div class="flex flex-row items-center gap-2 w-full font-medium m-0.5 p-1 bg-yellow-100 text-gray-900">
        <el-select v-model="organizationId" placeholder="organisatie" class="w-44" filterable>
            <el-option v-for="o in allOrganizations" :key="uuidOf(o)" :value="uuidOf(o)" :label="o.name"/>
        </el-select>
        <el-input v-model="initiatief.kwartaal" placeholder="YYYY-Qn" class="w-24" @change="onChange"/>
        <el-input v-model="initiatief.name" placeholder="initiatief" class="flex-1" @change="onChange"/>
        <el-select v-model="initiatief.fase" placeholder="fase" class="w-36" @change="onChange">
            <el-option v-for="f in Object.values(InitiatiefFaseEnum)" :key="f" :value="f" :label="InitiatiefFaseEnum_name(f)"/>
        </el-select>
        <el-input-number v-model="initiatief.impactIngeschatFte" :controls="false" :precision="2" class="w-24" title="ingeschat (FTE)" @change="onChange"/>
        <el-input-number v-model="initiatief.impactMeetplanFte" :controls="false" :precision="2" class="w-24" title="meetplan ZDC (FTE)" @change="onChange"/>
        <el-input-number v-model="initiatief.impactGemetenFte" :controls="false" :precision="2" class="w-24" title="gemeten (FTE)" @change="onChange"/>
        <el-input v-model="initiatief.thema" placeholder="thema" class="w-36" @change="onChange"/>
        <DeleteButton @click="onDelete()"/>
    </div>
</template>
